import Auth from '@aws-amplify/auth';
import { call, put, takeEvery } from 'redux-saga/effects';
import { Actions as AuthActions, Types as AuthTypes } from './../';

function* refreshPreferredMFA() {
  const authenticatedUser = yield call([Auth, 'currentAuthenticatedUser'], { bypassCache: true });
  const preferredMfa = yield call([Auth, 'getPreferredMFA'], authenticatedUser);

  yield put(AuthActions.updatePreferredMFA(preferredMfa));
}

export function* watchForRefreshPreferredMFAAction() {
  yield takeEvery(AuthTypes.REFRESH_PREFERRED_MFA, refreshPreferredMFA);
}
